<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div>
                <header>
                    <v-card-title> Base de datos </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div>
            
            <div class="content_main_report" v-if="!isLoading">
                <div class="container_img">
                    <img src="@/assets/images/databse_excel.svg" alt="">
                </div>
    
                <div class="container_data">
                    <div class="container_form">
                        <form class="mt-3 override_content_flex">
                            <div class="col-flex-12">
                                <v-select
                                    label="Tipo de Carga"
                                    v-model="formGroup.data.typeDatabase"
                                    :rules="formGroup.rules.typeDatabase"
                                    :items="arrTypeBasedata"
                                    prepend-icon="mdi-microsoft-excel"
                                    variant="outlined"
                                    item-title="value"
                                    item-value="key"
                                    @update:model-value="detectedType()"
                                    class="w-100"
                                ></v-select>
                            </div>
                            <div class="col-flex-12">
                                <v-file-input 
                                    label="Subir un archivo" 
                                    v-model="formGroup.data.fileDatabase"
                                    :rules="formGroup.rules.fileDatabase"
                                    variant="outlined"
                                    :accept="typeFile"
                                    class="w-100"
                                    :disabled="formGroup.data.typeDatabase === null"
                                ></v-file-input>
                            </div>
                            <div class="col-flex-12 actions_buttons">
                                <v-btn
                                    text="Cargar archivo"
                                    variant="flat"
                                    class="text-none elevation-0"
                                    color="indigo-darken-3"
                                    prepend-icon="mdi-file-document"
                                    :disabled="!validateForm()"
                                    @click="dialogAlert = true"
                                ></v-btn>
                            </div>
                        </form> 
                    </div>
                </div>
            </div>
            <div class="content_load" v-if="isLoading">
                <v-progress-circular
                    :size="100"
                    :width="7"
                    color="indigo-darken-3"
                    indeterminate
                ></v-progress-circular>
                <i>Espere un momento</i>
                <div>Cargando formulario</div>
            </div>
        </v-card>

        <template>
            <v-dialog v-model="dialogAlert" width="350px" persistent>
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Confirmación</span>
                    </v-card-title>
                    <div v-if="!isLoadingUpload">
                        <div class="text-center">
                            <img class="img_alert" src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <div>
                                ¿Está seguro de subir el archivo?
                            </div>
                            <div>
                                <i>Esta opción es irreversible</i>
                            </div>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoadingUpload">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Cargando los datos</div>
                    </div>
                    <v-card-actions class="actions_buttons">
                        <v-btn 
                            variant="flat"
                            class="text-none"
                            color="red"
                            :disabled="isLoadingUpload"
                            @click="dialogAlert = false"
                            text="Cerrar"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            class="text-none"
                            color="indigo-darken-3"
                            :disabled="isLoadingUpload"
                            @click="uploadFile()"
                            text="Generar"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-dialog v-model="dialogError" width="600px" persistent>
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Ocurrió un error</span>
                    </v-card-title>
                    <div v-if="!isLoadingUpload">
                        <div class="text-center">
                            <img class="img_alert" src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <div class="content_data_errors">
                                <div class="content_table">
                                    <div class="header_columna">Columna</div>
                                    <div class="header_columna">Fila</div>
                                    <div class="header_mensaje">Mensaje</div>
                                </div>
                                <div class="content_table" v-for="(item, index) in arrErrors" :key="index">
                                    <div class="item_columna">{{ item.columna }}</div>
                                    <div class="item_columna">{{ item.fila }}</div>
                                    <div class="item_mensaje">{{ item.mensaje }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <v-card-actions class="actions_buttons">
                        <v-btn 
                            variant="flat"
                            class="text-none"
                            color="red"
                            @click="dialogError = false"
                            text="Aceptar"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <SnackbarComponent :value="snackbarData"/>
    </div>
</template>
<script>
    import { DatabaseService } from '@/services/DatabaseService'
    import { useDebtorFieldsStore } from '@/stores/debtorFields'
    export default {
        name: 'LoginView',
        props: {
            msg: String
        },
        data () {
            return {
                isLoading: false,
                isLoadingUpload: false,
                dialogAlert: false,
                dialogError: false,
                arrErrors: [],
                arrTypeBasedata: [
                    {key: 'gm', value: 'Gestiones Masivas' },
                    {key: 'dm', value: 'Direcciones Masivas' },
                ],
                formGroup: {
                    data: {
                        typeDatabase: null,
                        fileDatabase: null,
                    },
                    rules: {
                        typeDatabase: [
                            value => {
                                if (value === null || value === '' || value === undefined) {
                                    return `El campo Tipo de Carga por es obligatorio`
                                }
                                return true
                            }
                        ],
                        fileDatabase: [
                            value => {
                                if (value === null || value === '' || value === undefined) {
                                    return `El campo Subir un archivo de Datos por es obligatorio`
                                }
                                return true
                            }
                        ]
                    }
                },
                snackbarData: {
                    openSnackbar: false,
                    description: '',
                },
                headersSCL: ['CLIENTE_UNICO','NOMBRE_CTE','GENERO_CLIENTE','EDAD_CLIENTE','OCUPACION','DIRECCION_CTE','NUM_EXT_CTE','NUM_INT_CTE','CP_CTE','COLONIA_CTE','POBLACION_CTE','ESTADO_CTE','TERRITORIO','TERRITORIAL','ZONA','ZONAL','NOMBRE_DESPACHO','GERENCIA','FECHA_ASIGNACION','DIAS_ASIGNACION','REFERENCIAS_DOMICILIO','CLASIFICACION_CTE','DIQUE','ATRASO_MAXIMO','DIAS_ATRASO','SALDO','MORATORIOS','SALDO_TOTAL','SALDO ATRASADO','SALDO REQUERIDO','PAGO_NORMAL','PRODUCTO','FECHA_ULTIMO_PAGO','IMP_ULTIMO_PAGO','CALLE_EMPLEO','NUM_EXT_EMPLEO','NUM_INT_EMPLEO','COLONIA_EMPLEO','POBLACION_EMPLEO','ESTADO_EMPLEO','NOMBRE_AVAL','TEL_AVAL','CALLE_AVAL','NUM_EXT_AVAL','COLONIA_AVAL','CP_AVAL','POBLACION_AVAL','ESTADO_AVAL','FIDIAPAGO','TELEFONO1','TELEFONO2','TELEFONO3','TELEFONO4','TIPOTEL1','TIPOTEL2','TIPOTEL3','TIPOTEL4','LATITUD','LONGITUD','DESPACHO_GESTIONO','ULTIMA_GESTION','GESTION_DESC','CAMPANIA_RELAMPAGO','CAMPANIA','TIPO_CARTERA','ID GRUPO','GRUPO_MAZ','CLAVE_SPEI','PAGOS_CLIENTE','MONTO_PAGOS','GESTORES','FOLIO_PLAN','SEGMENTO_GENERACION','ESTATUS_PLAN','SEMANAS_ATRASO','ATRASO','GENERACION_PLAN','CANCELACION_CUMPLIMIENTO_PLAN','ULTIMO_ESTATUS','EMPLEADO','CANAL','ABONO_SEMANAL','PLAZO','MONTO_ABONADO','MONTO_PLAN','ENGANCHE','PAGOS_RECIBIDOS','SALDO_ANTES_DEL_PLAN','SALDO_ATRASADO_ANTES_PLAN','MORATORIOS_ANTES_PLAN','ESTATUS_PROMESA_PAGO','MONTO_PROMESA_PAGO','CARTERA','RMD'],
                headersPayment: ['Fecha Recepción','CU Completo','Recuperación por Gestión'],
                headersCancel: ['CLIENTE_UNICO','ESTATUS_PLAN'],
                typeFile: null,
                permission: {
                    loadPaymentBase: false,
                    loadDatabase: false,
                    loadCanceledAgreements: false,
                    loadTelephones: false,
                }
            }
        },
        created() {

            const ENC_PERMISOS = localStorage.getItem('PERMISOS')
            const STR_PERMISOS = atob(ENC_PERMISOS)
            const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
            const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M09BADA')
            this.loadReportColumns()

            for (const element of PERMISSION.endpoints) {
                if (element.nombre === 'M09F02CBDA' && element.permiso === true) {
                    this.permission.loadDatabase = true
                    this.arrTypeBasedata.push({ key: 'scl', value: 'SCL' })
                }
                if (element.nombre === 'M09F03CBPA' && element.permiso === true) {
                    this.permission.loadPaymentBase = true
                    this.arrTypeBasedata.push({ key: 'excel pagos', value: 'Excel Pagos' })
                }
                if (element.nombre === 'M09F04CBCC' && element.permiso === true) {
                    this.permission.loadCanceledAgreements = true
                    this.arrTypeBasedata.push({ key: 'cancelar convenios', value: 'Cancelar Convenios' })
                }
                if (element.nombre === 'M09F0CBTE' && element.permiso === true) {
                    this.permission.loadTelephones = true
                    this.arrTypeBasedata.push({ key: 'tl', value: 'Carga Masiva Teléfonos' })
                }
            }

        },
        methods: {
            loadReportColumns: async function () {
                const store = useDebtorFieldsStore()
                if (!store.loaded) {
                    await store.cargar()
                }
                if (store.loaded && store.headers.length > 0) {
                    this.headersSCL = store.headers
                }
            },
            validateForm: function () {
                const TYPE_DATABASE = this.formGroup.data.typeDatabase
                if (TYPE_DATABASE === null || TYPE_DATABASE === undefined || TYPE_DATABASE === '') {
                    return false
                }

                const FILE_DATABASE = this.formGroup.data.fileDatabase
                if (FILE_DATABASE === null || FILE_DATABASE === undefined || FILE_DATABASE === '' || FILE_DATABASE.length === 0) {
                    return false
                }
                return true
            },
            uploadFile: async function () {
                let typeDatabase = this.formGroup.data.typeDatabase
                let fileDatabase = this.formGroup.data.fileDatabase

                const FILE = fileDatabase[0]
                switch (typeDatabase) {
                    case 'scl':
                        await this.loadSCL(FILE)
                        break;
                    case 'excel pagos':
                        await this.loadPayments(FILE)
                        break;
                    case 'cancelar convenios':
                        await this.loadCanceledAgreemets(FILE)
                        break;
                    case 'gm':
                        await this.loadBulkManagement(FILE)
                        break;
                    case 'dm':
                        await this.loadMassiveDirections(FILE)
                        break;
                    case 'tl':
                        await this.loadTelephones(FILE)
                        break;
                    default:
                        this.snackbarData.description = `Opción no disponible`
                        this.snackbarData.openSnackbar = true
                        return;
                }
                this.dialogAlert = false
            },
            loadSCL: async function (FILE) {
                this.isLoadingUpload = true
                if (this.permission.loadPaymentBase) {
                    const formData = new FormData();
                    formData.append("archivo", FILE);
                    formData.append("tipo_cartera", localStorage.getItem('TIPO_CARTERA'));
                    await DatabaseService.loadSCL(formData).then(
                        (responseData) => {
                            if (!responseData.error) {
                                this.snackbarData.description = `¡Carga de datos exitosa!`
                                this.snackbarData.openSnackbar = true
                                this.formGroup.data.typeDatabase = null
                                this.formGroup.data.fileDatabase = null
                            } else {
                                this.snackbarData.description = `${ responseData.msg }`
                                this.snackbarData.openSnackbar = true
                                this.arrErrors = responseData.response
                                this.dialogError = true
                            }
                        }
                    )
                } else {
                    this.snackbarData.description = `No tiene permisos para continuar`
                    this.snackbarData.openSnackbar = true
                }
                this.isLoadingUpload = false
            },
            loadPayments: async function (FILE) {
                this.isLoadingUpload = true
                if (this.permission.loadPaymentBase) {
                    const formData = new FormData();
                    formData.append("archivo", FILE);
                    await DatabaseService.loadPayments(formData).then(
                        (responseData) => {
                            if (!responseData.error) {
                                this.snackbarData.description = `¡Carga de datos exitosa!`
                                this.snackbarData.openSnackbar = true
                                this.formGroup.data.typeDatabase = null
                                this.formGroup.data.fileDatabase = null
                            } else {
                                this.snackbarData.description = `${ responseData.msg }`
                                this.snackbarData.openSnackbar = true
                            }
                        }
                    )
                } else {
                    this.snackbarData.description = `No tiene permisos para continuar`
                    this.snackbarData.openSnackbar = true
                }
                this.isLoadingUpload = false
            },
            loadCanceledAgreemets: async function (FILE) {
                this.isLoadingUpload = true
                if (this.permission.loadCanceledAgreements) {
                    const formData = new FormData();
                    formData.append("archivo", FILE);
                    await DatabaseService.loadCanceledAgreemets(formData).then(
                        (responseData) => {
                            if (!responseData.error) {
                                this.snackbarData.description = `¡Carga de datos exitosa!`
                                this.snackbarData.openSnackbar = true
    
                                this.formGroup.data.typeDatabase = null
                                this.formGroup.data.fileDatabase = null
    
                            } else {
                                this.snackbarData.description = `${ responseData.msg }`
                                this.snackbarData.openSnackbar = true
                            }
                        }
                    )
                } else {
                    this.snackbarData.description = `No tiene permisos para continuar`
                    this.snackbarData.openSnackbar = true
                }
                this.isLoadingUpload = false
            },
            loadBulkManagement: async function (FILE) {
                this.isLoadingUpload = true
                const formData = new FormData();
                    formData.append("archivo", FILE);
                    await DatabaseService.loadBulkManagement(formData).then(
                        (responseData) => {
                            if (!responseData.error) {
                                this.snackbarData.description = `¡Carga de datos exitosa!`
                                this.snackbarData.openSnackbar = true
    
                                this.formGroup.data.typeDatabase = null
                                this.formGroup.data.fileDatabase = null
    
                            } else {
                                this.snackbarData.description = `${ responseData.msg }`
                                this.snackbarData.openSnackbar = true
                            }
                        }
                    )
                this.isLoadingUpload = false
            },
            loadMassiveDirections: async function (FILE) {
                this.isLoadingUpload = true
                const formData = new FormData();
                    formData.append("archivo", FILE);
                    await DatabaseService.loadMassiveDirections(formData).then(
                        (responseData) => {
                            if (!responseData.error) {
                                this.snackbarData.description = `¡Carga de datos exitosa!`
                                this.snackbarData.openSnackbar = true
    
                                this.formGroup.data.typeDatabase = null
                                this.formGroup.data.fileDatabase = null
    
                            } else {
                                this.snackbarData.description = `${ responseData.msg }`
                                this.snackbarData.openSnackbar = true
                            }
                        }
                    )
                this.isLoadingUpload = false
            },
            loadTelephones: async function (FILE) {
                this.isLoadingUpload = true
                if (this.permission.loadTelephones) {
                    const formData = new FormData();
                    formData.append("archivo", FILE);
                    await DatabaseService.loadTelephones(formData).then(
                        (responseData) => {
                            if (!responseData.error) {
                                this.snackbarData.description = `¡Carga de datos exitosa!`
                                this.snackbarData.openSnackbar = true
    
                                this.formGroup.data.typeDatabase = null
                                this.formGroup.data.fileDatabase = null
    
                            } else {
                                this.snackbarData.description = `${ responseData.msg }`
                                this.snackbarData.openSnackbar = true
                            }
                        }
                    );
                }
                this.isLoadingUpload = false
            },
            detectedType: function () {
                const TYPE_DATABASE = this.formGroup.data.typeDatabase
                switch (TYPE_DATABASE) {
                    case 'scl':
                    case 'excel pagos':
                        this.typeFile = '.xlsx'
                        break;
                    case 'cancelar convenios':
                        this.typeFile = '.csv'
                        break;
                    default:
                        break;
                }
                this.formGroup.data.fileDatabase = null;
            },
        }
    }
</script>
<style scoped>
    .container_data {
        width: 100%;
        margin-top: 16px;
        overflow: auto;
        margin-bottom: 30px;
    }
    .container_form {
        max-width: 60%;
        min-width: 600px;
        margin: 0 auto;
    }
    .content_main_report {
        width: 100%; 
        height: calc(100% - 49px); 
        overflow: auto;
    }
    .container_img {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
    }
    .container_img img {
        max-height: 200px;
    }

    .img_alert {
        height: 230px;
        width: auto;
        padding: 40px;
    }

    .description-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        max-height: 250px;
        overflow: auto;
    }

    .description-text p {
        width: 90%;
        text-align: center;
        margin-bottom: 16px;
    }

    .content_table {
        display: flex;
        overflow: hidden;
    }

    .header_columna {
        width: 70px;
        display: flex;
        font-weight: 600;
        justify-content: center;
        align-items: center;
    }
    .header_mensaje {
        width: 350px;
        display: flex;
        font-weight: 600;
        align-items: center;
    }

    .item_columna {
        width: 70px;
        display: flex;
        justify-content: center;
    }

    .item_mensaje {
        width: 350px;
        display: flex;
        align-items: center;
    }
    
    .content_data_errors {
        max-height: 200px;
        overflow: auto;
    }
</style>